import counterpart from "counterpart";
import { VITE_isIE } from 'Constants/appEnvConstants';

export function analystDrawerMetaData() {
  return {
    id: 1,
    searchName: 'analystqueue',
    pageId: 'analyst_drawer',
    name: '',
    headerName: '',
    displayType: 'gdTable',
    recordCountRequired: false,
    isCheckboxOnRowRequired: false,
    titleRequired: false,
    isPagable: true,
    returnToText: 'Return',
    canManageColumns: false,
    primaryColumnKey: 'caseStageId',
    dataColumns: [
      {
        defaultIsVisible: true,
        description: 'Case Number',
        isRequired: true,
        isSortable: true,
        isSummaryColumn: false,
        name: 'Case Number',
        sortDirection: null,
        sortOrderPriority: 0,
        displayType: 'STRING',
        columnKey: 'caseNumber',
        bindKey: '',
        displayOrder: 1,
        elementId: 'case_number',
      },
      {
        defaultIsVisible: true,
        description: 'Due Date',
        isRequired: true,
        isSortable: true,
        isSummaryColumn: false,
        name: 'Due Date',
        sortDirection: null,
        sortOrderPriority: 0,
        displayType: 'DATE',
        bindKey: '',
        columnKey: 'dueDate',
        elementId: 'due-dt',
        displayOrder: 2,
      },
      {
        defaultIsVisible: true,
        description: 'Dispute Amount',
        isRequired: true,
        isSortable: true,
        isSummaryColumn: false,
        name: 'Dispute Amount',
        sortDirection: null,
        sortOrderPriority: 0,
        displayType: 'CURRENCY',
        bindKey: '',
        columnKey: 'disputeAmount',
        elementId: 'dsp_amt',
        displayOrder: 3,
      },

      {
        defaultIsVisible: true,
        description: 'Reason Code',
        isRequired: true,
        isSortable: true,
        isSummaryColumn: false,
        name: 'Reason Code',
        sortDirection: null,
        sortOrderPriority: 0,
        displayType: 'RC',
        bindKey: '',
        columnKey: 'disputeReasonCode',
        elementId: 'rsn_code',
        displayOrder: 4,
      },
      {
        defaultIsVisible: true,
        description: '',
        isRequired: false,
        isSortable: false,
        isSummaryColumn: false,
        name: '',
        sortDirection: null,
        sortOrderPriority: 0,
        displayType: 'ICON',
        columnKey: 'OpenInNewTabIcon',
        displayOrder: 99,
        isSelected: true,
      }
    ],
    actions: [

    ],
    defaultSort: [{
      key: 'disputeAmount',
      order: 0,
    }],
    dateFormat: 'MM/DD/YYYY',
    isExportable: false,
    paginationRequired: false,
  };
}


export function queueMetaData(permission, userId, checkboxEnabled) {
  return {
    id: 1,
    searchName: 'myqueue',
    pageId: 'queue_mgmt',
    name: ' ',
    headerName: 'Queues',
    displayType: 'gdTable',
    recordCountRequired: false,
    isCheckboxOnRowRequired: (permission !== undefined && permission !== null && permission.case.canAssignCase && permission.case.canUnAssignCase && checkboxEnabled) ? true : false,
    titleRequired: true,
    isPagable: true,
    detailViewTitle: 'Case Details',
    returnToText: 'Return',
    canManageColumns: true,
    primaryColumnKey: 'caseStageId',
    dataColumns: [
    ],
    actions:[
       {
         title: 'Unresolve',
         url: 'landing',
         key: 'UNRESOLVE_RTI',
         style: {
          width: '150px',
          justifyContent: 'left',
         }
       },{
        title: 'View More Details',
        url: 'landing',
        key: 'DETAIL_DRAWER',
        style: {
         width: '150px',
         justifyContent: 'left',
        }
      },
        {
          title: 'Open Case',
          url: 'landing',
          key: 'OPEN_CASE',
          style: {
            width: '115px',
            paddingLeft: '0px',
          },
        }
      ]
    ,
    defaultSort: [
      {
        key: 'actionedDate', 
        order: 1,
      }
    ],
    pageSize: 25,
    dateFormat: 'MM/DD/YYYY',
    isExportable: true,
    paginationRequired: true,
  };
}

export function getAnalystHeaderCountDataColumns() {
  return [
    {
      id: 1,
      title: 'Workable',
      displayType: 'STRING',
      description: 'Workable',
      columnKey: 'workableCount',
    },
    {
      id: 2,
      title: 'Critical',
      displayType: 'CRITICAL',
      description: 'Critical',
      columnKey: 'criticalCount',
    },
  ];
}

export function getRegionHeaderCountDataColumns() {
  return [
    {
      id: 1,
      title: 'Total',
      displayType: 'STRING',
      description: 'Total',
      columnKey: 'workableCount',
    },
    {
      id: 2,
      title: 'Critical',
      displayType: 'CRITICAL',
      description: 'Critical',
      columnKey: 'criticalCount',
    },
  ];
}

export function getData() {
  return {
    content:
      [
        {
          caseNumber: '987654441',
          caseStageId: '30971',
          maskedCardNumber: '123456XXXXXX9876',
          merchantName: 'KEAT DEE TRADING',
          cardBrandCode: 'DI',
          acquirerBinIca: '620054',
          acquirerReferenceNumber: '76200544215473140591459',
          issuerBinIca: '601100',
          tranAmount: '100.00',
          transactionDate: '2014-08-01',
          transactionTime: null,
          disputeAmount: '50.00',
          disputeReasonCode: 'UA01',
          statusName: 'Close',
          disputeStageName: 'Retrieval Request',
          merchantNumber: '30414311',
          cardBrandRegionCode: 'AP',
          glCompanyName: null,
          reasonDescription: 'Fraud Card Present Transaction',
          operationDescription: null,
          merchantDescription: null,
          dueDate: '2018-06-22',
          daysRemaining: 3,
          globalToken: '8600K41256892241',
          currencyCode: 'USD',
        },
        {
          caseNumber: '987654441',
          caseStageId: '30971',
          maskedCardNumber: '123456XXXXXX9876',
          merchantName: 'KEAT DEE TRADING',
          cardBrandCode: 'DI',
          acquirerBinIca: '620054',
          acquirerReferenceNumber: '76200544215473140591459',
          issuerBinIca: '601100',
          tranAmount: '100.00',
          transactionDate: '2014-08-01',
          transactionTime: null,
          disputeAmount: '150.00',
          disputeReasonCode: 'UA01',
          statusName: 'Close',
          disputeStageName: 'Retrieval Request',
          merchantNumber: '30414311',
          cardBrandRegionCode: 'AP',
          glCompanyName: null,
          reasonDescription: 'Fraud Card Present Transaction',
          operationDescription: null,
          merchantDescription: null,
          dueDate: '2017-06-22',
          daysRemaining: 3,
          globalToken: '8600K41256892241',
          currencyCode: 'USD',

        },
        {
          caseNumber: '987654441',
          caseStageId: '30971',
          maskedCardNumber: '123456XXXXXX9876',
          merchantName: 'KEAT DEE TRADING',
          cardBrandCode: 'DI',
          acquirerBinIca: '620054',
          acquirerReferenceNumber: '76200544215473140591459',
          issuerBinIca: '601100',
          tranAmount: '100.00',
          transactionDate: '2014-08-01',
          transactionTime: null,
          disputeAmount: '250.00',
          disputeReasonCode: 'UA01',
          statusName: 'Close',
          disputeStageName: 'Retrieval Request',
          merchantNumber: '30414311',
          cardBrandRegionCode: 'AP',
          glCompanyName: null,
          reasonDescription: 'Fraud Card Present Transaction',
          operationDescription: null,
          merchantDescription: null,
          dueDate: '2015-06-22',
          daysRemaining: 3,
          globalToken: '8600K41256892241',
          currencyCode: 'USD',
        },
        {
          caseNumber: '987654441',
          caseStageId: '30971',
          maskedCardNumber: '123456XXXXXX9876',
          merchantName: 'KEAT DEE TRADING',
          cardBrandCode: 'DI',
          acquirerBinIca: '620054',
          acquirerReferenceNumber: '76200544215473140591459',
          issuerBinIca: '601100',
          tranAmount: '100.00',
          transactionDate: '2014-08-01',
          transactionTime: null,
          disputeAmount: '350.00',
          disputeReasonCode: 'UA01',
          statusName: 'Close',
          disputeStageName: 'Retrieval Request',
          merchantNumber: '30414311',
          cardBrandRegionCode: 'AP',
          glCompanyName: null,
          reasonDescription: 'Fraud Card Present Transaction',
          operationDescription: null,
          merchantDescription: null,
          dueDate: '2019-06-02',
          daysRemaining: 3,
          globalToken: '8600K41256892241',
          currencyCode: 'USD',
        },
        {
          caseNumber: '987654441',
          caseStageId: '30971',
          maskedCardNumber: '123456XXXXXX9876',
          merchantName: 'KEAT DEE TRADING',
          cardBrandCode: 'DI',
          acquirerBinIca: '620054',
          acquirerReferenceNumber: '76200544215473140591459',
          issuerBinIca: '601100',
          tranAmount: '100.00',
          transactionDate: '2014-08-01',
          transactionTime: null,
          disputeAmount: '450.00',
          disputeReasonCode: 'UA01',
          statusName: 'Close',
          disputeStageName: 'Retrieval Request',
          merchantNumber: '30414311',
          cardBrandRegionCode: 'AP',
          glCompanyName: null,
          reasonDescription: 'Fraud Card Present Transaction',
          operationDescription: null,
          merchantDescription: null,
          dueDate: '2019-06-2',
          daysRemaining: 3,
          globalToken: '8600K41256892241',
          currencyCode: 'USD',
        },
      ],
    pageable: {
      sort: {
        sorted: false,
        unsorted: true,
        empty: true,
      },
      pageSize: 25,
      pageNumber: 0,
      offset: 0,
      paged: true,
      unpaged: false,
    },
    totalElements: 1,
    last: true,
    totalPages: 1,
    first: true,
    sort: {
      sorted: false,
      unsorted: true,
      empty: true,
    },
    number: 0,
    numberOfElements: 1,
    size: 25,
    empty: false,


  };
}

export function getTranslations() {
  return {
    corpAndRegion:'Search Corp and Region',
    reasonCode:'Search Reason Code',
    applyFilterPane: 'Search',
    cancel: 'Cancel',
    clearFilterPane: 'Clear',
    less: 'Less',
    more: 'More',
    save: 'Save',
    select: 'Select',
    dates: {
      apply: 'Apply',
      cancel: 'Cancel',
      custom: 'Custom',
      fri: 'Fri',
      from: 'From',
      lastMonth: 'Last Month',
      lastSevenDays: 'Last 7 Days',
      lastThirtyDays: 'Last 30 Days',
      lastWeek: 'Last Week',
      lastYear: 'Select Date(s)',
      mon: 'Mon',
      sat: 'Sat',
      sun: 'Sun',
      thisMonth: 'This Month',
      thisYear: 'This Year',
      thu: 'Thu',
      to: 'To',
      tue: 'Tue',
      unselectedText: 'Select Date(s)',
      validDateError: 'Please enter a valid date.',
      wed: 'Wed',
      yesterday: 'Yesterday',
      jan:'January',
      feb:'February',
      mar:'March',
      apr:'April',
      may:'May',
      jun:'June',
      jul:'July',
      aug:'August',
      sep:'September',
      oct:'October',
      nov:'November',
      dec:'December',
    },
    actions: 'Actions',
    active: 'Active',
    addAll: 'Add All',
    apply: 'Apply',
    applyFilterPane: 'Apply',
    backLinkText: 'Back to Reports',
    cancel: 'Cancel',
    clearAll: 'Clear All',
    clear: 'Reset',
    columns: 'Columns',
    createAFilterContent: 'To select a filter, please create a filter.',
    createAFilterTitle: 'Start by creating a filter',
    currency: 'Currency',
    export: 'Export',
    exporting: 'Exporting',
    exportTypesTitle: 'What do you want to export?',
    fileName: 'Name of file:',
    fileTypesTitle: 'Export As:',
    fileNameLabel: 'Name of File:',
    filterPaneTriggerText: 'Filter',
    filters: 'Filters',
    header: 'Export Data',
    hideAll: 'Hide All',
    inactive: 'Inactive',
    less: 'Less',
    more: 'More',
    next: 'Next',
    prev: 'Prev',
    page: 'Page',
    placeholder: 'Search by Filter Name...',
    preposition: 'of',
    removeAll: 'Remove All',
    save: 'Save',
    savedFilters: 'Saved Filters',
    searchCurrencies: 'Search Currencies',
    shareReport: 'Share Report',
    showAll: 'Show All',
    show25perPage: 'Show 25 per page',
    show50perPage: 'Show 50 per page',
    show75perPage: 'Show 75 per page',
    show100perPage: 'Show 100 per page',
    showingRecords: 'Showing records',
    summaryTitle: 'Summary',
    title: 'Saved Filters',
    saveFilterLabel: 'Filter Name',
    saveFilterTitle: 'Save Filter',
    availableColumns: 'Available Columns',
    availableFilterText: 'Available Filters',
    searchAvailableFilters: 'Search Report Filters',
    searchAvailableColumns: 'Search Available Columns',
    activeColumns: 'Active Columns',
    selected: 'Selected',
    searchActiveColumns: 'Search Active Columns',
    cardNum: 'Account Number (first 6 or last 4 digits)',
    helperText: '(first 6 or last 4 digits)',
    first6Placeholder: counterpart('globalTranslate.queues.firstSix'),
    last4Placeholder: counterpart('globalTranslate.queues.lastFour'),
    searchReasonCodePlaceholder: counterpart('globalTranslate.caseSearch.searchReasonCode'),
  };
}

export function getFilterValues() {
  return [
    {
      id: 1,
      value: 'New',
      valueLabel: 'New ',
      desc: 'English description of New',
      filterValueGroupId: 1,
    },
    {
      id: 2,
      value: 'Open',
      valueLabel: 'Open ',
      desc: 'English description of Open',
      filterValueGroupId: 1,
    },
    {
      id: 3,
      value: 'Closed',
      valueLabel: 'Closed',
      desc: 'English description of Closed',
      filterValueGroupId: 1,
    },
    {
      id: 4,
      value: 'Pended',
      valueLabel: 'Pended',
      desc: 'English description of Pended',
      filterValueGroupId: 1,
    },
  ];
}


export function getValidations(elementTypeName) {
  return [
    {
      id: 'DATE',
      validations: [
        {
          validationRuleKey: 'DATE_RANGE_VALIDATION',
          validationRef: '',
          translatedErrorMessage: 'Start Date must be before End Date. Check the dates and try again.',
          sequence: 0,
        },
      ],
    },
  ].find((queueMetaData) => {
    return queueMetaData.id === elementTypeName;
  });
}

export function getSavedFilters() {
  return [
    {
      id: 929,
      name: 'This_Year',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":"case_trans_date","name":"Original Transaction Date","value":"this_year","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 930,
      name: 'Test203',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 931,
      name: 'last month',
      filterJson: '[{"v1":"last_month","type":"EXACT","id":133,"name":"Original Transaction Date","value":"last_month","values":null},{"v1":"0","v2":"203","type":"BETWEEN","id":134,"name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 932,
      name: 'this month',
      filterJson: '[{"v1":"this_month","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_month","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 933,
      name: 'custom',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 934,
      name: 'trtyy',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null},{"v1":"0","v2":"203","id":134,"type":"BETWEEN","name":"Original Transaction Amount","value":null,"values":{"v1":"0","v2":"203"}}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
    {
      id: 935,
      name: 'test01',
      filterJson: '[{"v1":"this_year","type":"EXACT","id":133,"name":"Original Transaction Date","value":"this_year","values":null}]',
      email: 'gp_tech_support_admin@globalpay.com',
    },
  ];
}


export function addIconsToGDTableHeadersList(columns,userPermission) {
  let canViewBookMark= userPermission && userPermission.case ?userPermission.case.canBookmark:false;
  const iconsColumns = columns.find((column) => column.displayType == 'ICON' && column.description == '');
  if (!iconsColumns) {
    // canViewBookMark && columns.unshift({
    //   defaultIsVisible: false,
    //   description: '',
    //   isRequired: false,
    //   isSortable: false,
    //   isSummaryColumn: false,
    //   name: '',
    //   sortDirection: null,
    //   sortOrderPriority: 0,
    //   displayType: 'ICON',
    //   columnKey: 'BookMarkIcon',
    //   displayOrder: -1,
    //   isSelected: true,
    // });
  if(userPermission !== undefined && userPermission !== null && userPermission.case.canAssignCase){
    // columns.unshift({
    //   defaultIsVisible: true,
    //   description: 'Checkbox',
    //   isRequired: false,
    //   isSortable: false,
    //   isSummaryColumn: false,
    //   name: '',
    //   sortDirection: null,
    //   sortOrderPriority: 0,
    //   displayType: 'ICON',
    //   columnKey: 'checkboxIcon',
    //   displayOrder: -2,
    //   isSelected: true,
    // });
  }
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'OpenInNewTabIcon',
      displayOrder: 99,
      isSelected: true,
    });
    columns.push({
      defaultIsVisible: true,
      description: '',
      isRequired: false,
      isSortable: false,
      isSummaryColumn: false,
      name: '',
      sortDirection: null,
      sortOrderPriority: 0,
      displayType: 'ICON',
      columnKey: 'FolderIcon',
      displayOrder: 100,
      isSelected: true,
    });
  }
  return columns;
}

export function getActionPanelDetailToShow() {
  return [
    { id: '8', viewCode: 'URTI', actionType: 'UNRESOLVEDRTI', url: 'api/v1/casemanager/unresolve/action', isVisible: true, extraStyle: VITE_isIE ? { width: 260 } : { width: 300 }, extraPrimaryButtonClass: '', showProgressButton: false, actionPrimaryButtonText: 'Submit', actionDescription: 'sample Action description', actionSelectionList: [{ value: false, text: 'Internal' }] },
  ];
}

export function getSelectionActionList() {
  var shortCutStyle = `color:#9a9fac;float:right;display:inline - flex`;
  return [
     { id: '8', viewCode: 'URTI', value: 'Unresolve RTI', text: `Add Case Notes <strong style=${shortCutStyle}>CTRL+ALT+E</strong>`, color: '#007dc3' },
   ];
}
